import { render } from "./GDQAdmin.vue?vue&type=template&id=068eccb8&scoped=true"
import script from "./GDQAdmin.vue?vue&type=script&lang=js"
export * from "./GDQAdmin.vue?vue&type=script&lang=js"

import "./GDQAdmin.vue?vue&type=style&index=0&id=068eccb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068eccb8"]])

export default __exports__